<template>
  <div class="lifecycle">
    <el-radio-group
      v-model="tabPosition"
      style="margin-bottom: 30px"
      class="ft"
    >
      <el-radio-button label="1">生命周期</el-radio-button>
      <el-radio-button label="2">ltv分析</el-radio-button>
    </el-radio-group>
    <!-- 生命周期 -->
    <div v-show="tabPosition == 1">
      <el-card shadow="never" class="title" style="height: 200px">
        <div class="top clearfix">
          <!-- 标题 -->
          <div class="fl">
            <img
              src="../../assets/images/newIcon/vip_lifecycle_icon@2x.png"
              alt=""
            />
            <span></span><b style="font-weight: 500">用户生命周期</b
            ><span class="text">各个生命周期节点的用户统计数据</span>
          </div>
          <!-- 右侧区域 -->
          <div class="fr">
            <p>
              <img
                src="../../assets/images/newIcon/ss_shaixuan_icon.png"
                alt=""
              />
              <!-- 1 -->
              <el-select
                style="width: 100px"
                v-model="def1"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
                <el-date-picker
                  v-if="isshow"
                  v-model="value1"
                  class="rqc"
                  ref="int"
                  type="date"
                >
                </el-date-picker>
              </el-select>
              <!-- 2 -->
              <el-select
                style="width: 100px"
                v-model="def2"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
              <!-- 3 -->
              <el-select
                style="width: 100px"
                v-model="def3"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options3"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </p>
          </div>
        </div>
        <p class="date">7-26 (当周)</p>
        <!-- 数据展示区域 -->
        <ul>
          <li>
            <p>
              新用户
              <el-tooltip
                class="item"
                effect="dark"
                content="统计时间范围内新增的用户数量"
                placement="right"
              >
                <img src="../../assets/images/newIcon/tishi_icon.png" alt="" />
              </el-tooltip>
            </p>
            <p>199<span>人</span></p>
            <p>
              同比<span class="red">5.9% <i class="el-icon-top"></i></span>
            </p>
          </li>
          <li>
            <p>
              连续活跃用户
              <el-tooltip
                class="item"
                effect="dark"
                content="本周有过访问且上周也有访问的用户（这里需要注意一下，因为我们是支持自定义时间筛选的，如果筛选了自定义时间，则按自定义时间的结束时间的那一周去计算，那一周访问过且再上一周也有同步访问的情况下，则计算入内。）"
                placement="right"
              >
                <img src="../../assets/images/newIcon/tishi_icon.png" alt="" />
              </el-tooltip>
            </p>
            <p>199<span>人</span></p>
            <p>
              同比<span class="gru">5.9% <i class="el-icon-bottom"></i></span>
            </p>
          </li>
          <li>
            <p>
              回流用户
              <el-tooltip
                class="item"
                effect="dark"
                content="上周未登录的用户在本周有登录行为（这里也需要注意一下，如果自定义时间筛选的情况下，按结束时间的那一周计算，就是结束时间的那一周有访问，且上周没有访问的用户，为回流用户）"
                placement="right"
              >
                <img src="../../assets/images/newIcon/tishi_icon.png" alt="" />
              </el-tooltip>
            </p>
            <p>199<span>人</span></p>
            <p>
              同比<span class="gru">5.9% <i class="el-icon-bottom"></i></span>
            </p>
          </li>
          <li>
            <p>
              沉睡用户
              <el-tooltip
                class="item"
                effect="dark"
                content="本周未登录，上周有过登录的用户（若自定义情况下，按结束时间的那一周计算）"
                placement="right"
              >
                <img src="../../assets/images/newIcon/tishi_icon.png" alt="" />
              </el-tooltip>
            </p>
            <p>199<span>人</span></p>
            <p>
              同比<span class="red">5.9% <i class="el-icon-top"></i></span>
            </p>
          </li>
          <li>
            <p>
              流失用户
              <el-tooltip
                class="item"
                effect="dark"
                content="近14天未登录客户（如果是自定义时间的情况下，按结束时间的那一天的近14天计算）"
                placement="right"
              >
                <img src="../../assets/images/newIcon/tishi_icon.png" alt="" />
              </el-tooltip>
            </p>
            <p>199<span>人</span></p>
            <p>
              同比<span class="red">5.9% <i class="el-icon-top"></i></span>
            </p>
          </li>
          <li>
            <p>
              流入流出比
              <el-tooltip
                class="item"
                effect="dark"
                content="新用户+回流客户/流失客户（若自定义情况下， 根据上面统计返回的新用户、回流用户、流失用户数据去计算）"
                placement="right"
              >
                <img src="../../assets/images/newIcon/tishi_icon.png" alt="" />
              </el-tooltip>
            </p>
            <p>199<span>人</span></p>
            <p>
              同比<span class="red">5.9% <i class="el-icon-top"></i></span>
            </p>
          </li>
        </ul>
      </el-card>
      <!-- 柱形图 -->
      <el-card shadow="never" class="title bar">
        <div class="top clearfix">
          <div class="fl">
            <img
              src="../../assets/images/newIcon/viplifecycle_report_icon@2x.png"
              alt=""
            />
            <span></span><b style="font-weight: 500">统计报表</b
            ><span class="text">所选时间内的用户生命周期占比</span>
          </div>
          <!-- 右侧区域 -->
          <div class="fr">
            <p>
              <img
                src="../../assets/images/newIcon/ss_shaixuan_icon.png"
                alt=""
              />
              <!-- 1 -->
              <el-select
                style="width: 100px"
                v-model="def11"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options11"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
                <el-date-picker
                  v-if="isshow"
                  v-model="value1"
                  class="rqc"
                  ref="int1"
                  type="date"
                >
                </el-date-picker>
              </el-select>
              <!-- 2 -->
              <el-select
                style="width: 100px"
                v-model="def22"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options22"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
              <!-- 3 -->
              <el-select
                style="width: 100px"
                v-model="def33"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options33"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </p>
          </div>
        </div>
        <div ref='c1' id="c1" style="margin-left: 50px; width: 90%"></div>
      </el-card>
      <!-- 条形图 -->
      <el-card shadow="never" class="title bar">
        <div class="top clearfix">
          <div class="fl">
            <img
              src="../../assets/images/newIcon/viplifecycle_andflow_icon@2x.png"
              alt=""
            />
            <span></span><b style="font-weight: 500">流入流出比</b>
          </div>
          <!-- 右侧区域 -->
          <div class="fr">
            <p>
              <img
                src="../../assets/images/newIcon/ss_shaixuan_icon.png"
                alt=""
              />
              <!-- 1 -->
              <el-select
                style="width: 100px"
                v-model="def111"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options111"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
                <el-date-picker
                  v-if="isshow"
                  v-model="value1"
                  class="rqc"
                  ref="int2"
                  type="date"
                >
                </el-date-picker>
              </el-select>
              <!-- 2 -->
              <el-select
                style="width: 100px"
                v-model="def222"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options222"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
              <!-- 3 -->
              <el-select
                style="width: 100px"
                v-model="def333"
                placeholder="请选择"
                class="my-select"
              >
                <el-option
                  v-for="item in options333"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </p>
          </div>
        </div>
        <div id="c2"></div>
      </el-card>
    </div>
    <!-- ltv -->
    <div v-if="tabPosition == 2">
      <el-card shadow="never">
        注册用户在7/15/30/90天的人均支付金额（LTV 7 / LTV 15 / LTV 30 / LTV 90）
      </el-card>
      <div class="ity-chart">
        <el-card shadow="never" class="card-chart">
          <line-chart
            lid="l1"
            LTV="7"
            date="2021-07-21～2021-07-27 近7天"
            type="1"
          ></line-chart>
        </el-card>
        <el-card shadow="never" class="card-chart">
          <line-chart
            lid="l2"
            LTV="15"
            date="2021-07-21～2021-07-27 近15天"
            type="2"
          ></line-chart>
        </el-card>
        <el-card shadow="never" class="card-chart">
          <line-chart
            lid="l3"
            LTV="30"
            date="2021-06-28～2021-07-27 近30天"
            type="3"
          ></line-chart>
        </el-card>
        <el-card shadow="never" class="card-chart">
          <line-chart
            lid="l4"
            LTV="90"
            date="2021-06-28～2021-07-27 近90天"
            type="4"
          ></line-chart>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  registerTheme,
  Chart,
  registerInteraction,
  interaction,
  G2,
} from "@antv/g2";
import lineChart from "./components/lineChart.vue";
export default {
  components: {
    lineChart,
  },
  data() {
    return {
      value: [{ name: "7月", value: "1" }],
      tabPosition: "1",
      //显示日期组件
      isshow: false,
      value1: null,
      def1: "昨日",
      def2: "业务系统",
      def3: "终端渠道",
      def11: "昨日",
      def22: "业务系统",
      def33: "终端渠道",
      def111: "昨日",
      def222: "业务系统",
      def333: "终端渠道",
      options1: [
        { name: "昨日" },
        { name: "近30天" },
        { name: "近90天" },
        { name: "近半年" },
        { name: "近一年" },
        { name: "自定义周期" },
      ],
      options2: [{ name: "小橘帮帮" }, { name: "颐安中台" }],
      options3: [{ name: "小程序" }, { name: "app" }],
      options11: [
        { name: "昨日" },
        { name: "近30天" },
        { name: "近90天" },
        { name: "近半年" },
        { name: "近一年" },
        { name: "自定义周期" },
      ],
      options22: [{ name: "小橘帮帮" }, { name: "颐安中台" }],
      options33: [{ name: "小程序" }, { name: "app" }],
      options111: [
        { name: "昨日" },
        { name: "近30天" },
        { name: "近90天" },
        { name: "近半年" },
        { name: "近一年" },
        { name: "自定义周期" },
      ],
      options222: [{ name: "小橘帮帮" }, { name: "颐安中台" }],
      options333: [{ name: "小程序" }, { name: "app" }],
    };
  },
  watch: {
    value1() {
      if (this.value1) {
        this.isshow = false;
      }
    },
    def1() {
      if (this.def1 == "自定义周期") {
        this.isshow = true;
        this.$nextTick(() => {
          this.$refs.int.focus();
        });
      } else {
        this.isshow = false;
      }
    },
    def11() {
      if (this.def11 == "自定义周期") {
        this.isshow = true;
        this.$nextTick(() => {
          this.$refs.int1.focus();
        });
      } else {
        this.isshow = false;
      }
    },
    def111() {
      if (this.def111 == "自定义周期") {
        this.isshow = true;
        this.$nextTick(() => {
          this.$refs.int2.focus();
        });
      } else {
        this.isshow = false;
      }
    },
  },
  mounted() {
    //柱形图里两个按钮的点击事件
      this.$refs.c1.addEventListener('click',(e)=>{
        if(e.target.classList[1] == 'btn1'){
          console.log('查看用户列表');
        }else if (e.target.classList[1] == 'btn2'){
          console.log('运营用户分组');
        }
      })
    //柱形图
    this.init();
    //折线图
    this.init2();
  },
  methods: {
    log1() {
      console.log("111");
    },
    init() {
      const data = [
        {
          type: "连续活跃用户",
          name: "06.20当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "流失用户",
          name: "06.20当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "沉睡用户",
          name: "06.20当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "新用户",
          name: "06.20当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "回流用户",
          name: "06.20当周",
          value: Math.ceil(Math.random() * 800),
        },

        {
          type: "连续活跃用户",
          name: "07.05当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "流失用户",
          name: "07.05当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "沉睡用户",
          name: "07.05当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "新用户",
          name: "07.05当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "回流用户",
          name: "07.05当周",
          value: Math.ceil(Math.random() * 800),
        },

        {
          type: "连续活跃用户",
          name: "07.12当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "流失用户",
          name: "07.12当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "沉睡用户",
          name: "07.12当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "新用户",
          name: "07.12当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "回流用户",
          name: "07.12当周",
          value: Math.ceil(Math.random() * 800),
        },

        {
          type: "连续活跃用户",
          name: "07.19当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "流失用户",
          name: "07.19当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "沉睡用户",
          name: "07.19当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "新用户",
          name: "07.19当周",
          value: Math.ceil(Math.random() * 800),
        },
        {
          type: "回流用户",
          name: "07.19当周",
          value: Math.ceil(Math.random() * 800),
        },

        { type: "连续活跃用户", name: "07.26当周", value: 288 },
        { type: "流失用户", name: "07.26当周", value: 314 },
        { type: "沉睡用户", name: "07.26当周", value: 203 },
        { type: "新用户", name: "07.26当周", value: 124 },
        { type: "回流用户", name: "07.26当周", value: 345 },
      ];
      const chart = new Chart({
        container: "c1",
        autoFit: true,
        height: 300,
      });
      registerTheme("newTheme", { minColumnWidth: 20, maxColumnWidth: 40 });
      chart.theme("newTheme");
      //设置Y轴的最大最小值
      chart.scale("value", {
        min: 0,
        max: 3000,
      });

      chart.data(data);

      chart.tooltip({
        enterable: true, //是否允许鼠标滑入
        follow: true, // tooltip 是否跟随鼠标移动
        position: "right", // 固定位置展示 tooltip
        triggerOn: "click", // tooltip 的触发方式，默认为 mousemove
        shared: false, // 默认为 true, false 表示只展示单条 tooltip
        showMarkers: false,
        inPlot: false, // 将 tooltip 展示在指定区域内
        containerTpl: `<div @click="log1" class="g2-tooltip" style="width:185px;height:174px;"> 
          <div class="g2-tooltip-title" style="margin:10px 0;"></div>
          <span class="el-icon-close"></span>
          <ul class="g2-tooltip-list"></ul>
          <div><ul class="btn3">
          <li style="width:144px;height:34px;z-index:99;" ref="btn" class="buleBtn btn1">查看用户列表</li>
          <li style="width:144px;height:34px;" class="buleBtn btn2">运营用户分组</li>
          </ul></div>
          </div>`, // tooltip 容器模板
        itemTpl: `
                    <div style="margin-bottom: 10px;list-style:none;">
                    <span style="background-color:{color};display:inline-block; transform: translate(-30px, 0px);" class="g2-tooltip-marker"></span>
                    <span style="display:inline-block; transform: translate(-37px, 0px);">{name}</span><span style="display:inline-block; transform: translate(25px, 0px);"><span style="color:{color};font-size: 17px;" >{value}</span><span style="font-size:10px;">人</span></span>
                    </div>
                `, // 自定义 toolTip 样式
      });
      chart
        .interval()
        .position("name*value")
        .color("type", ["#5B8FF9", "#5AD8A6 ", "#F7B500", "#FF7F7F", "#6236FF"])
        .adjust("stack");

      // chart.removeInteraction('tooltip');
      // registerInteraction('axis-label-highlight', {
      // start: [{ trigger: 'axis-label:mouseenter', action: ['list-active:active', 'element-active:active'] }],
      // end: [{ trigger: 'axis-label:mouseleave', action: ['list-active:reset', 'element-active:reset'] }],
      // });
      // chart.interaction('axis-label-highlight',);
      // chart.interaction('tooltip', {
      //     start: [{ trigger: 'plot:click', action: 'tooltip:show' }],

      // });

      chart.interaction("active-region");

      chart.render();
    },
    init2() {
      let d1 = [
        { data: "06.25当周", name: "流入流出比", val: 130 },
        { data: "07.05当周", name: "流入流出比", val: 760 },
        { data: "07.12当周", name: "流入流出比", val: 220 },
        { data: "07.19当周", name: "流入流出比", val: 230 },
        { data: "07.26当周", name: "流入流出比", val: 900 },
      ];
      let data = [...d1];

      const chart = new this.$chart({
        container: "c2",
        autoFit: true,
        height: 330,
        padding: [40, 60, 80, 60],
      });
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      chart.scale("val", {
        min: 0,
        max: 1000,
      });

      chart.tooltip({
        showCrosshairs: true,
        shared: true,
        itemTpl: `
                    <div style="margin-bottom: 10px;list-style:none;">
                    <span style="background-color:{color};" class="g2-tooltip-marker"></span>
                    {name}:{value}
                    </div>
                `, // 自定义 toolTip 样式
      });

      chart.axis("val", {
        label: {
          formatter: (val) => {
            return val;
          },
        },
      });
      chart
        .line()
        .position("data*val")
        .color("name", ["#5292FF"])
        .shape("smooth");
      // chart.point().position("data*val").color("name").shape("circle");
      chart.render();
    },
  },
};
</script>
<style lang="less">
.lifecycle {
  padding: 20px;
  padding-top: 30px;
  //两个按钮
  .ft {
    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 18px 0 0 18px;
      width: 81px;
    }
    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 18px 18px 0;
      width: 81px;
    }
  }
  .title {
    //下方标题区域
    .top {
      margin-top: -5px;
      .fl {
        float: left;
        font-size: 16px;
        display: flex;
        b {
          margin-left: 6px;
        }
        img {
          width: 24px;
        }
        .text {
          margin-left: 12px;
          color: #333;
          font-size: 12px;
          line-height: 24px;
        }
      }
      .fr {
        float: right;
        color: #999999;
        font-size: 12px;
        p {
          img {
            width: 16px;
            vertical-align: middle;
            //   margin-right: 10px;
          }
        }
        .my-select {
          margin-left: 10px;
        }
      }
    }
    .date {
      margin-left: 25px;
      font-size: 14px;
      color: #327eff;
      font-weight: 600;
      line-height: 20px;
    }
    ul {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      margin-left: 20px;
      li {
        margin-bottom: 30px;
        text-align: left;
        width: 33.3%;
        box-sizing: border-box;
        p {
          padding-bottom: 10px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(37, 49, 62, 0.85);
          img {
            width: 16px;
            vertical-align: middle;
          }
          &:nth-child(2) {
            font-size: 24px;
            font-weight: bold;
            // color: #327eff;
            span {
              font-size: 14px;
            }
          }
          &:last-child {
            font-size: 12px;
            font-weight: 400;
            color: #7e858c;
            span {
              padding-left: 10px;
            }
          }
        }
        &:nth-child(3n) {
          p {
            border: 0px;
          }
        }
      }
    }
  }
  .bar {
    margin-top: 20px;
    #c1 {
      margin: 0 auto;
      margin-top: 10px;
      height: 500px;
      width: 80%;
    }
  }
  //ity界面
  .ity-chart {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .card-chart {
      margin-top: 20px;
      width: 49%;
      height: 500px;
    }
  }
  //公用区域
  .g2-tooltip-marker {
    border-radius: 0 !important;
  }
  .el-icon-close {
    position: absolute;
    font-size: 16px;
    top: 6px;
    right: 18px;
  }
  .g2-tooltip {
    display: block !important;
  }
  .btn3 {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    > li {
      &:nth-child(1) {
        margin-top: 10px;
        transform: translate(0px, -25px);
      }
      &:nth-child(2) {
        margin-top: 10px;
        transform: translate(0px, -50px);
      }
    }
  }
  .buleBtn {
    width: 144px !important;
    height: 34px !important;
    border-radius: 4px !important;
    border: 1px solid #327eff !important;
    font-size: 12px !important;
    color: #327eff !important;
    line-height: 34px !important;
    text-align: center !important;
  }
  .gru {
    color: #19e9aa !important;
  }
  .red {
    color: red !important;
  }
}
</style>